import React from "react"

import Image from "gatsby-plugin-sanity-image"
import PropTypes from "prop-types"

import * as styles from "./newsletter-gist-picks.module.scss"
import DarkColor from "../../../helpers/dark-color"
import isRegion from "../../../helpers/newsletter-region"
import CopyContainer from "../../atoms/copy-container"
import Heading from "../../atoms/heading"

const NewsletterGistPicks = ({ section, country, city, segment, styling }) => {
  const imageMarkup = (pick) => (
    <div className={styles.imageWrap}>
      {pick.url ? (
        <a href={pick.url} target="_blank" rel="noreferrer">
          <Image
            {...pick.image}
            className={styles.image}
            width={100}
            height={100}
          />
        </a>
      ) : (
        <Image
          {...pick.image}
          className={styles.image}
          width={100}
          height={100}
        />
      )}
    </div>
  )

  return (
    <>
      {styling !== "lifestyle" ? (
        <CopyContainer className={styles.intro} content={section._rawIntro} />
      ) : (
        ""
      )}
      <div
        className={`${styles.wrapper} ${styles[`wrapper__${styling}`]}  ${styles[`wrapper__${section.color?.replaceAll("-", "")}`]}`}
      >
        {styling === "lifestyle" && section._rawIntro ? (
          <CopyContainer
            className={styles.intro__lifestyle}
            content={section._rawIntro}
          />
        ) : (
          ""
        )}
        {section.content.map((pick, index) =>
          isRegion(pick, country, city, segment) ? (
            <div className={styles.pick}>
              {pick.image ? imageMarkup(pick) : ""}
              {section.numbered ? (
                <div
                  className={`${styles.number} ${
                    DarkColor(section.color) ? styles.number__light : ""
                  }`}
                >
                  {index + 1}.
                </div>
              ) : (
                ""
              )}
              <div className={styles.content}>
                {pick.title ? <Heading level={4} html={pick.title} /> : ""}
                <CopyContainer
                  bg={DarkColor(section.color) ? "black" : ""}
                  content={pick._rawContent}
                />
              </div>
            </div>
          ) : (
            ""
          )
        )}
      </div>
    </>
  )
}

export default NewsletterGistPicks

NewsletterGistPicks.propTypes = {
  section: PropTypes.object.isRequired,
  country: PropTypes.string.isRequired,
  city: PropTypes.string.isRequired,
  segment: PropTypes.string.isRequired,
  styling: PropTypes.string,
}

NewsletterGistPicks.defaultProps = {
  styling: "",
}
